var map = {
	"./3d-scanners.json": [
		479,
		4
	],
	"./6g-network.json": [
		480,
		5
	],
	"./affective-computing.json": [
		481,
		6
	],
	"./ai-avatar.json": [
		482,
		7
	],
	"./ar-eyewear.json": [
		483,
		8
	],
	"./artificial-neural-networks.json": [
		484,
		9
	],
	"./blockchain-based-browser.json": [
		485,
		10
	],
	"./brain-machine-interfaces.json": [
		486,
		11
	],
	"./brain-to-brain-communication.json": [
		487,
		12
	],
	"./data-exchange-layer.json": [
		488,
		13
	],
	"./decentralised-applications.json": [
		489,
		14
	],
	"./decentralised-storage.json": [
		490,
		15
	],
	"./digital-wallets.json": [
		491,
		16
	],
	"./edge-data-centers.json": [
		492,
		17
	],
	"./example-tech-data.json": [
		493,
		18
	],
	"./exascale-computers.json": [
		494,
		19
	],
	"./faraday-shield.json": [
		495,
		20
	],
	"./free-space-optical-communication.json": [
		496,
		21
	],
	"./fungible-tokens.json": [
		497,
		22
	],
	"./generative-adversarial-network.json": [
		498,
		23
	],
	"./generative-pre-trained-transformers.json": [
		499,
		24
	],
	"./geoblocking-and-filtering.json": [
		500,
		25
	],
	"./haptics.json": [
		501,
		26
	],
	"./intelligent-virtual-agent.json": [
		502,
		27
	],
	"./kernel-level-anti-cheat-systems.json": [
		503,
		28
	],
	"./live-streaming-api.json": [
		504,
		29
	],
	"./machine-translation.json": [
		505,
		30
	],
	"./microelectromechanical-systems.json": [
		506,
		31
	],
	"./mind-upload.json": [
		507,
		32
	],
	"./neurostimulation.json": [
		508,
		33
	],
	"./non-fungible-tokens.json": [
		509,
		34
	],
	"./on-skin-interface.json": [
		510,
		35
	],
	"./photonic-integrated-circuit.json": [
		511,
		36
	],
	"./piezoelectric-generators.json": [
		512,
		37
	],
	"./platform-agnostic-cloud-computing.json": [
		513,
		38
	],
	"./post-quantum-cryptography.json": [
		514,
		39
	],
	"./quantum-cloud-computing.json": [
		515,
		40
	],
	"./ray-tracing.json": [
		516,
		41
	],
	"./real-time-facial-motion-capture.json": [
		517,
		42
	],
	"./self-destructing-data-system.json": [
		518,
		43
	],
	"./self-mixing-interferometry.json": [
		519,
		44
	],
	"./sidechains-and-offchains.json": [
		520,
		45
	],
	"./smart-contract.json": [
		521,
		46
	],
	"./solid-state-battery.json": [
		522,
		47
	],
	"./source-to-source-compiler.json": [
		523,
		48
	],
	"./space-based-solar-power.json": [
		524,
		49
	],
	"./spectral-rendering.json": [
		525,
		50
	],
	"./subvocal-recognition.json": [
		526,
		51
	],
	"./technologies.json": [
		527,
		52
	],
	"./trusted-execution-environment.json": [
		528,
		53
	],
	"./vehicle-to-vehicle-communication-(v2x).json": [
		529,
		54
	],
	"./vein-based-biometric-authentication.json": [
		530,
		55
	],
	"./virtual-scents.json": [
		531,
		56
	],
	"./virtual-taste-simulators.json": [
		532,
		57
	],
	"./volumetric-displays.json": [
		533,
		58
	],
	"./vr-locomotion.json": [
		534,
		59
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 190;
module.exports = webpackAsyncContext;